import { render, staticRenderFns } from "./TodoTask.vue?vue&type=template&id=02105c8e&scoped=true&"
import script from "./TodoTask.vue?vue&type=script&lang=js&"
export * from "./TodoTask.vue?vue&type=script&lang=js&"
import style0 from "./TodoTask.vue?vue&type=style&index=0&id=02105c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02105c8e",
  null
  
)

export default component.exports